import "core-js/es/array/find";
import "core-js/es/array/includes";
import "core-js/es/string/starts-with";
import "core-js/es/string/ends-with";
import "core-js/es/string/includes";

import { ThemeProvider } from "@mui/material/styles";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { CssBaseline } from "@mui/material";
import enGB from "date-fns/locale/en-GB";
import fi from "date-fns/locale/fi";
import sv from "date-fns/locale/sv";
import React from "react";
import { HashRouter } from "react-router-dom";
import { FeedbackProvider } from "./context/FeedbackContext";
import { UserProvider } from "./context/UserContext";
import { MainView } from "./components/views/MainView";
import { pharmadosTheme } from "./theme/AppTheme";

const DATE_LOCALE_MAPPING: { [key: string]: any } = {
  "en-gb": enGB,
  "fi": fi,
  "sv": sv,
};

export const App: React.FC = () => {
  return (
    <ThemeProvider theme={pharmadosTheme}>
      <UserProvider>
        <FeedbackProvider>
          <HashRouter>
            <LocalizationProvider
              dateAdapter={AdapterDateFns}
              adapterLocale={DATE_LOCALE_MAPPING["fi"]}>
              <CssBaseline />
              <MainView />
            </LocalizationProvider>
          </HashRouter>
        </FeedbackProvider>
      </UserProvider>
    </ThemeProvider>
  );
};
